import React from 'react'
import { Col, Row } from 'reactstrap';
import icon1 from '../../assets/images/icon1.svg'
import icon2 from '../../assets/images/icon2.svg'
import icon3 from '../../assets/images/icon3.svg'
import { GiWorld } from "react-icons/gi";
import { useNavigate } from 'react-router-dom';

const HomeAbout = () => {
    const navigation = useNavigate()

    return (
        <div className='home-about'>
            <Row>
                <Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-3'>
                    <div className='item'>
                        <div>
                            <div className='about-title'>
                                <div><img src={icon1} alt='' /></div>
                                <div className='title mt-3'><span>Mobile Optimization</span></div>
                            </div>
                            <div className='subtitle mt-2'><span>Ensure your content looks perfect on every device with built-in mobile-friendly designs.</span></div>
                        </div>
                    </div>
                </Col>
                <Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-3'>
                    <div className='item'>
                        <div>
                            <div className='about-title'>
                                <div><img src={icon2} alt='' /></div>
                                <div className='title mt-3'><span>Advanced Analytics</span></div>
                            </div>
                            <div className='subtitle mt-2'><span>Track user engagement and performance with detailed insights directly from your CMS.</span></div>
                        </div>
                    </div>
                </Col>
                <Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-3'>
                    <div className='item'>
                        <div>
                            <div className='about-title'>
                                <div><img src={icon3} alt='' /></div>
                                <div className='title mt-3'><span>Intuitive Dashboard</span></div>
                            </div>
                            <div className='subtitle mt-2'><span>Manage your content with ease using our user-friendly dashboard, designed for simplicity and efficiency.</span></div>
                        </div>
                    </div>
                </Col>
            </Row>
            <div className='center'>
                <div className='home-about-btn' onClick={() => navigation('/contact')}>
                    <GiWorld size={20} />
                    <span>Learn More About libeCMS</span>
                </div>
            </div>
        </div>
    )
}

export default HomeAbout
